import React from 'react';
import { Provider } from 'react-redux';

import { createBrowserHistory } from 'history';

import GlobalStyles from '@iso/assets/styles/globalStyle';
import { Auth0Provider } from '@iso/config/react-auth0-spa';

import Routes from './router';
import Boot from './redux/boot';
import { store } from './redux/store';
import AppProvider from './AppProvider';
import AuthorizedApolloProvider from './AuthorizedApolloProvider';

const history = createBrowserHistory();

const onRedirectCallback = () => {
  history.push('/dashboard');
};

const App = () => (
  <Auth0Provider
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    audience={process.env.REACT_APP_AUDIENCE}
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    client_id={process.env.REACT_APP_AUTH0_CLIENT_ID}
  >
    <Provider store={store}>
      <AuthorizedApolloProvider>
        <AppProvider>
          <>
            <GlobalStyles />
            <Routes />
          </>
        </AppProvider>
      </AuthorizedApolloProvider>
    </Provider>
  </Auth0Provider>
);

Boot()
  .then(() => App())
  .catch((error) => console.error(error));

export default App;
